import * as React from "react";
import { Banknote, Truck, Recycle, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const solutions = [{
  title: "Instant Cash Offers",
  description: "Get top dollar for your junk car on the spot. We evaluate your vehicle and pay cash immediately upon pickup.",
  icon: Banknote
}, {
  title: "Free Same-Day Towing",
  description: "No hidden fees. We provide fast, reliable, and completely free towing services across all our BC service areas.",
  icon: Truck
}, {
  title: "Eco-Conscious Recycling",
  description: "We ensure your scrap car is dismantled and recycled following strict environmental standards to protect our beautiful province.",
  icon: Recycle
}];
export default function OurScrapCarSolutions() {
  return <section id="our-scrap-car-solutions" className="dark bg-background text-foreground relative overflow-hidden py-24 px-4 md:px-8">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 10px, var(--color-foreground) 10px, var(--color-foreground) 12px), repeating-linear-gradient(-45deg, transparent, transparent 10px, var(--color-foreground) 10px, var(--color-foreground) 12px)`,
      backgroundSize: '40px 40px'
    }} aria-hidden="true" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight">
            Our Scrap Car <span className="text-primary">Solutions</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Eco-friendly, fast, and profitable ways to dispose of your unwanted vehicles in British Columbia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map((solution, i) => {
          const Icon = solution.icon;
          return <Card key={i} data-index={i} className="group relative bg-card/50 backdrop-blur-sm border-border/50 overflow-hidden transition-all duration-500 hover:border-primary hover:shadow-[0_0_30px_-5px_var(--color-primary)] hover:-translate-y-1">
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                
                <CardHeader className="pb-4 relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-background border border-border/50 flex items-center justify-center mb-6 transition-transform duration-500 group-hover:-translate-y-2 group-hover:scale-110 group-hover:border-primary/50 group-hover:bg-primary/10 shadow-lg">
                    <Icon className="w-8 h-8 text-primary" />
                  </div>
                  <CardTitle className="text-2xl font-bold tracking-tight group-hover:text-primary transition-colors duration-300">
                    {solution.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10">
                  <CardDescription className="text-base text-muted-foreground leading-relaxed">
                    {solution.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="text-lg px-8 py-6 rounded-full shadow-[0_0_20px_-5px_var(--color-primary)] hover:shadow-[0_0_30px_-5px_var(--color-primary)] transition-all duration-300">
            <Link to="/ContactPage">
              Get Your Free Quote Now
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}